import React, { useState, useEffect } from 'react'
import { Building2, Link2 } from 'lucide-react'
import { toast } from 'sonner'

const API = process.env.REACT_APP_BACKEND_URL
const TYPES_TRANSPORT = ['rc_transport', 'ad_valorem']

async function putPolice(policeId, body) {
  const res = await fetch(`${API}/api/polices/${policeId}`, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
  const d = await res.json()
  if (!res.ok || !d.success) throw new Error(d.detail || 'Erreur')
  return d.police
}

/** Rattachement transport d'une police : entite (hierarchie complete), police RC liee, provision nette de franchise. */
export default function PoliceTransportPanel({ police, tenantId, onUpdate }) {
  const [entites, setEntites] = useState([])
  const [polices, setPolices] = useState([])
  const isTransport = TYPES_TRANSPORT.includes(police.type_police)

  useEffect(() => {
    if (!isTransport) return
    fetch(`${API}/api/entites?tenant_id=${tenantId}`).then(r => r.json()).then(d => setEntites(d.entites || [])).catch(() => {})
    fetch(`${API}/api/polices?tenant_id=${tenantId}`).then(r => r.json()).then(d => setPolices((d.polices || []).filter(p => p.type_police === 'rc_transport' && p.id !== police.id))).catch(() => {})
  }, [tenantId, police.id, isTransport])

  if (!isTransport) return null

  async function save(body, msg) {
    try { await putPolice(police.id, body); toast.success(msg); onUpdate?.() } catch (e) { toast.error(e.message) }
  }

  return (
    <div className="bg-white border border-sky-200 rounded-lg p-5" data-testid="police-transport-panel">
      <h3 className="text-sm font-semibold text-slate-700 mb-3 flex items-center gap-2"><Building2 size={14} className="text-sky-600" /> Rattachement transport</h3>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 text-sm">
        <div>
          <p className="text-xs text-slate-400 mb-0.5">Entite couverte {police.type_police === 'ad_valorem' ? '(mere ou filiale ; couvre ses filles)' : '(vide = groupe)'}</p>
          <select value={police.entite_id || ''} onChange={e => save({ entite_id: e.target.value || '' }, 'Entite enregistree')} className="w-full px-2 py-1.5 border border-slate-200 rounded-lg bg-white" data-testid="select-police-entite">
            <option value="">— Groupe (toutes entites) —</option>
            {entites.filter(e => e.actif !== false).map(e => <option key={e.id} value={e.id}>{e.chemin}</option>)}
          </select>
        </div>
        {police.type_police === 'ad_valorem' && (
          <div>
            <p className="text-xs text-slate-400 mb-0.5 flex items-center gap-1"><Link2 size={11} /> Police RC transport liee</p>
            <select value={police.police_liee_id || ''} onChange={e => save({ police_liee_id: e.target.value || '' }, 'Police liee enregistree')} className="w-full px-2 py-1.5 border border-slate-200 rounded-lg bg-white" data-testid="select-police-liee">
              <option value="">— aucune —</option>
              {polices.map(p => <option key={p.id} value={p.id}>{`${p.numero_police} — ${p.libelle || ''}`}</option>)}
            </select>
            {polices.length === 0 && <p className="text-[10px] text-amber-600 mt-0.5">Aucune police RC transport active chez ce client</p>}
          </div>
        )}
        <div>
          <p className="text-xs text-slate-400 mb-0.5">Releve compagnie : provision nette de franchise ?</p>
          <label className="flex items-center gap-2 cursor-pointer">
            <input type="checkbox" checked={!!police.provision_nette_de_franchise} onChange={e => save({ provision_nette_de_franchise: e.target.checked }, 'Parametre enregistre')} className="w-4 h-4 accent-sky-600" data-testid="toggle-provision-nette" />
            <span className="text-slate-700 text-xs">{police.provision_nette_de_franchise ? 'Oui — la franchise n\'est pas deduite une 2e fois dans le S/P' : 'Non — provision brute, franchise deduite dans le S/P'}</span>
          </label>
        </div>
      </div>
    </div>
  )
}
